var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0,100.2L60.0,98.874L60.0,180.0L84.0,180.0L84.0,97.547L112.0,96.0L112.0,76.2L36.0,80.0L36.0,100.2ZM0.0,34.0L152.0,0.0L152.0,256.0L0.0,222.0L0.0,34.0ZM177.979,100.031C170.543,100.031 163.982,96.332 160.0,90.684L160.0,65.378C163.982,59.731 170.543,56.031 177.979,56.031C190.129,56.031 199.979,65.881 199.979,78.031C199.979,90.181 190.129,100.031 177.979,100.031ZM179.190,208.022C168.562,208.022 160.0,204.0 160.0,204.0L160.0,112.0L204.0,112.0L204.0,188.0C204.0,188.0 204.0,208.022 179.190,208.022ZM233.779,112.031C221.629,112.031 211.779,102.181 211.779,90.031C211.779,77.881 221.629,68.031 233.779,68.031C245.929,68.031 255.779,77.881 255.779,90.031C255.779,102.181 245.929,112.031 233.779,112.031ZM212.0,188.0C212.0,175.8 212.0,124.0 212.0,124.0L256.0,124.0C256.0,124.0 256.0,157.0 256.0,168.2C256.0,176.0 249.6,188.0 212.0,188.0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.200be706bd2d9683874825e271519c40.svg";
export { ForwardRef as ReactComponent };